import _ from 'lodash';

const check = (authObj, aclGroups) => {
  const groups = _.cloneDeep(aclGroups);
  // groups.push('admin');
  const currentAcl = _.get(authObj, 'ACL.list') || [];
  // console.log("AUTH", authObj);
  // console.log("CURRENT ACL", currentAcl);
  // console.log("GROUPS", groups);
  // console.log("SOME", groups.some((v) => currentAcl.indexOf(v) >= 0));
  return groups.some((v) => currentAcl.indexOf(v) >= 0);
};

const checkIsTutor = (authObj, aclGroups) => {
  if (Array.isArray(aclGroups) && aclGroups.includes('tutor') && authObj.isTutor) {
    return true;
  }
  return false;
};

export default {
  check,
  checkIsTutor,
};



// WEBPACK FOOTER //
// ./app/shared/lib/acl/index.js